import { useData } from "../../../runtime/provider";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { favouritesQuery } from "./queryFunctions";

/**
 * Top-10 favourites list. Switched to a plain `useQuery` (was
 * `useSuspenseQuery`) to support `initialData` from the durable SQLite
 * cache — `useSuspenseQuery` doesn't accept `initialData`, and the cold-
 * start instant-render contract requires it. Consumers handle the
 * `data: undefined` case with `?? []` defaulting.
 */
export const useFavourites = () => {
  const data = useData();
  const query = useQuery(favouritesQuery(data));

  useEffect(() => {
    if (query.data) {
      for (const item of query.data) {
        switch (item.collectionType) {
          case "album":
            data.utils.catalog.albums.getById.setData(
              [item.collectionId],
              [item],
            );
            break;
          case "artist":
            data.utils.catalog.artists.get.setData([item.collectionId], [item]);
            break;
          case "playlist":
            break;
        }
      }
    }
  }, [data, query.data]);

  return query;
};
